import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MicrosoftTokenBundle } from '../models';
import { OutlookSyncHttpBase } from './outlook-sync-http-base';

@Injectable()
export class MicrosoftAuthSyncService extends OutlookSyncHttpBase {
  exchangeOAuthCode(
    code: string,
    redirectUri: string,
    configurationId: string,
  ): Observable<boolean> {
    return this.http
      .post<void>(
        `${this.apiUrl}/v1/microsoft-auth/sync-configurations/${configurationId}/exchange-code`,
        { code, redirectUri },
        {
          headers: this.buildHeaders({ ignoreInsights: true }),
          observe: 'response',
        },
      )
      .pipe(
        this.mapStatusOk({
          allowed: [HttpStatusCode.Ok, HttpStatusCode.NoContent],
        }),
      );
  }

  exchangeCodeForTokens(
    code: string,
    redirectUri: string,
  ): Observable<MicrosoftTokenBundle> {
    return this.http.post<MicrosoftTokenBundle>(
      `${this.apiUrl}/v1/microsoft-auth/exchange-code`,
      { code, redirectUri },
      {
        headers: this.buildHeaders({ ignoreInsights: true }),
      },
    );
  }
}
